import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// TT-607: React Router v6 with BrowserRouter doesn't reset scroll on navigation.
// Scrolling happens at the window level (body-content is overflow:hidden, minHeight:100vh),
// so navigating from a scrolled-down list left the next page sitting at the old offset.
// Reset to the top on every pathname change. Keyed on pathname (not search) so it doesn't
// fight in-page scrolls that only change query params (e.g. transcript search).
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
